import React from "react";
import Navbar from "./Navbar";

function Hero(props) {
    const heroBgStyle = {
    backgroundImage: `linear-gradient(
      to right,
      rgba(0,0,0, 0.4),
      rgba(0,0,0, 0.4)
    ), url(${props.bgimg})`,
  };

    return (
        <>
            <section id="hero">
                <Navbar />
                <div className="container-fluid hero-bg" id="hero-cnt" style={heroBgStyle}>
                    <div className="row " >
                        
                        <div className="col-md-12 col-12 col-sm-12 col-lg-12">
                            <div className="hero-content" data-aos="zoom-in">
                                <h1 className="hero-h1">
                                    {props.title}
                                </h1>
                                <p className="hero-p">
                                   {props.content}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

            </section>
        </>
    )
}

export default Hero;